import * as React from "react";
const SvgPartAdd20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 2H1v14h9v-2H3V4h12v5h2V2H2Zm7 4.5L6.5 9 9 11.5 11.5 9 9 6.5Zm6 9.5h-3v-2h3v-3h2v3h3v2h-3v3h-2v-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgPartAdd20Px;
